import styled from 'styled-components';
import { COLORS } from '@Commons';

type SizeProps = {
  $width?: number | string;
  $height?: number | string;
};

const toCSS = (value: number | string) => (typeof value === 'number' ? `${value}px` : value);

export const Container = styled.div<SizeProps>`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 12px;
  ${({ $width }) => $width !== undefined && `width: ${toCSS($width)};`}
  ${({ $height }) => $height !== undefined && `height: ${toCSS($height)};`}
`;

export const CardRow = styled.div`
  display: flex;
  flex-direction: row;
  height: 160px;
  border-radius: 4px;
  border: 1px solid ${COLORS.lightGrey};
  overflow: hidden;
`;

export const ContentSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ImageSection = styled.div`
  width: 118px;
  flex-shrink: 0;
  background-color: ${COLORS.tableBorderGrey};
`;
